import React from 'react'
import styled from 'styled-components'
import logo from '../../Constants/Variants/Logos/AF_WERFEN/AF_WERFEN_BN/PNG/AF_WERFEN_BN_POS_RGB.png'

/*
 *  @Description:   Stateless component that presents a Footer.
 */
const Image = styled.img`
    width: 300px;
    opacity: 0.3;
`;
const StyledDiv = styled.div`
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 2%;
`;

const Footer = ( { className, text } ) => (
    <footer
        className={ className }
    >
        <StyledDiv>
            <Image src={ logo }/>
            {
                text &&
                <p>{ text }</p>
            }
        </StyledDiv>
    </footer>
);


export default Footer;